import React from 'react'
import Link from 'gatsby-link'
import Slider from 'react-slick'

import "../../../node_modules/slick-carousel/slick/slick.css"
import "../../../node_modules/slick-carousel/slick/slick-theme.css"
import "./styles.css"

const settings = {
  arrows: false,
  autoplay: true,
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  fade: true,
  cssEase: 'linear'
}

const Feature = () => (
  <div
    className="feature"
  >
    <div className="hero">
      <h1>
        With your plans we have the experience and expertise to make your project happen.
      </h1>
    </div>
    <Slider {...settings}>
      <div className="slide-1"></div>
      <div className="slide-2"></div>
      <div className="slide-3"></div>
      <div className="slide-4"></div>
    </Slider>
  </div>
)

export default Feature


// WEBPACK FOOTER //
// ./src/components/Feature/index.js